import type { ApiRequestStatus } from '@makemydeal/dr-shared-types';
import type { DealProposalState } from './types';

type RootStateWithDealProposal = { dealProposal?: DealProposalState } | null | undefined;

export const getDealProposalFetchStatus = (state: RootStateWithDealProposal): ApiRequestStatus | undefined =>
    state?.dealProposal?.requestStatus;
